export default "__VITE_ASSET__bc7f9985__"